import { observer } from "mobx-react-lite";
import { Form, Input, Modal, Button, Select } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import AppStore from "../../../../stores/User/AppStore";
export interface TagEditDialogProps {
  visible: boolean;
  close: () => void;
  tagInfo: {
    name: string;
    id: string;
  };
}

const TagEditDialog: React.FC<TagEditDialogProps> = (props) => {
  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue({ tag: props.tagInfo.name });
  }, [props.visible]);

  const submit = () => {
    form
      .validateFields()
      .then((res) => {
        console.log(res);
        const { tag } = form.getFieldsValue();
        AppStore.editTag(props.tagInfo.id, tag);
        props.close();
      })
      .catch((err) => {});
    const { tag } = form.getFieldsValue();
    console.log(tag, "tag");
  };
  return (
    <Modal
      forceRender
      title="编辑标签"
      visible={props.visible}
      onCancel={props.close}
      onOk={submit}
      okText="确认"
      cancelText="取消"
    >
      <Form form={form} name="dynamic_form_item">
        <Form.Item
          validateTrigger={["onChange", "onBlur"]}
          rules={[
            {
              required: true,
              whitespace: true,
              message: "输入标签名",
            },
          ]}
          name="tag"
          label="标签名称"
        >
          <Input placeholder="请输入标签名" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default observer(TagEditDialog);
